const translations = {
  'project.title': 'Proyectos',
  'project.edit': 'Editando proyecto',
  'project.new': 'Nuevo proyecto',
  'project.create': 'Creando proyecto',
  'project.cloning': 'Clonando proyecto',
  'project.cloning.subtitle': 'Esta acción creará un nuevo proyecto con los mismos datos del proyecto',
  'project.remove.confirmation': '¿Está seguro de que desea eliminar?',
  'project.remove.success': '¡Proyecto eliminado con éxito!',
  'project.remove.error': '¡Ocurrió un error al eliminar!',
  'project.form.field.name': 'Nombre',
  'project.form.field.color': 'Color',
  'project.form.field.icon': 'Icono',
  'project.list.item.action.edit': 'Editar',
  'project.list.item.action.remove': 'Eliminar',
  'project.list.item.new.project': 'Nuevo proyecto',
  'project.templates.createNew': 'Crear nuevo',
  'project.templates.newProjectDescription': 'Nuevo proyecto.',
  'project.templates.new': 'Nuevo',
  'project.templates.templates': 'Plantillas',
  'project.templates.selectTemplate': 'Seleccione una plantilla'
}

export default translations
